import React, { useState } from "react";
import { List, ListItem, ListItemIcon, ListItemText, TextField, Typography } from "@material-ui/core";
import _debounce from "lodash/debounce";
import moment from "moment";
import MobileIcon from "@material-ui/icons/PhoneIphone";
import BrowserIcon from "@material-ui/icons/WebAsset";
import { useAppContext } from "store/context";

const Devices = ({ devices, handleChange }) => {
  const { station } = useAppContext();
  const debounceChange = _debounce((device_id, value) => handleChange(device_id, value), 500);

  return (
    <List dense disablePadding>
      {devices.map((device) => (
        <ListItem key={device.device_id}>
          <ListItemIcon>
            {device.is_mobile ? <MobileIcon fontSize="large" /> : <BrowserIcon fontSize="large" />}
          </ListItemIcon>
          <NicknameInput device={device} current_id={station.id} handleChange={debounceChange} />
        </ListItem>
      ))}
    </List>
  );
};

const NicknameInput = ({ device, current_id, handleChange }) => {
  const { device_id, device_detail, device_nickname, last_login } = device;
  const [value, setValue] = useState(device_nickname);

  const onNicknameChange = (device_id, value) => {
    setValue(value);
    handleChange(device_id, value);
  };

  return (
    <ListItemText
      disableTypography
      primary={
        <TextField
          id={`device-nickname-${device_id}`}
          label="Nickname"
          placeholder="barista-station-01"
          fullWidth
          value={value}
          margin="dense"
          onChange={(e) => onNicknameChange(device_id, e.target.value)}
        />
      }
      secondary={
        <Typography variant="caption">
          {device_detail}
          {device_id === current_id ? ` (this device)` : null}| Last Login: {moment(last_login).format("llll")}
        </Typography>
      }
    />
  );
};

export default Devices;
